<template>
    <div class="step-layout">
        <!-- Step Intro Section -->
        <section class="step-layout-left bg-1">
            <div class="step-layout-container">
                <div class="progressbar"></div>
                <h2
                    class="text-white intro-title d-none d-sm-block"
                    data-aos="fade-up"
                    data-aos-duration="1300"
                    v-html="bannerTitle"
                ></h2>
                <h2
                    class="text-white intro-title d-block d-sm-none text-center"
                    data-aos="zoom-in"
                    data-aos-duration="1300"
                    v-html="bannerMobileTitle"
                ></h2>

                <div
                    class="text-center text-sm-left"
                    data-aos="fade-up"
                    data-aos-duration="1600"
                >
                    <!-- <a
                        href="javascript:void(0)"
                        class="btn btn-primary"
                        @click="goBack()"
                    >
                        <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                    </a> -->
                </div>
            </div>
        </section>
        <!-- Step Form Section -->
        <section class="step-layout-right">
            <div
                class="step-layout-container"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <h2 class="text-primary title" v-html="valuationTitle"></h2>
                <form class="text-center" action="#">
                    <div class="form-group input-group-lg text-left">
                        <!-- <label for="full_name">Name <span class="text-danger">*</span></label> -->
                        <input
                            type="text"
                            v-model="name"
                            name="full_name"
                            class="form-control"
                            :class="
                                $v.name.$error
                                    ? 'is-invalid'
                                    : $v.name.required
                                    ? 'is-valid'
                                    : ''
                            "
                            @input="$v.name.$touch()"
                            placeholder="Full name"
                        />
                        <div
                            class="text-left invalid-feedback"
                            v-if="$v.name.$error"
                        >
                            Name is required
                        </div>
                    </div>
                    <div class="form-group input-group-lg text-left">
                        <!-- <label for="email_addr">Email <span class="text-danger">*</span></label> -->
                        <input
                            type="email"
                            v-model="email"
                            name="email_addr"
                            class="form-control"
                            :class="
                                $v.email.$error
                                    ? 'is-invalid'
                                    : $v.email.required && $v.email.email
                                    ? 'is-valid'
                                    : ''
                            "
                            @input="$v.email.$touch()"
                            placeholder="E-mail"
                        />
                        <div
                            class="text-left invalid-feedback"
                            v-if="$v.email.$error"
                        >
                            <template v-if="!$v.email.required"
                                >Email is required</template
                            >
                            <template v-else-if="!$v.email.email"
                                >Email must be a valid email address</template
                            >
                        </div>
                    </div>
                    <div class="form-group input-group-lg text-left">
                        <!-- <label for="phone_no">Phone <span class="text-danger">*</span></label> -->
                        <input
                            type="text"
                            v-model="phone"
                            name="phone_no"
                            class="form-control"
                            :class="
                                $v.phone.$error
                                    ? 'is-invalid'
                                    : $v.phone.required &&
                                      $v.phone.canadianNumber
                                    ? 'is-valid'
                                    : ''
                            "
                            @input="$v.phone.$touch()"
                            placeholder="Phone"
                        />
                        <div
                            class="text-left invalid-feedback"
                            v-if="$v.phone.$error"
                        >
                            <template v-if="!$v.phone.required"
                                >Phone number is required</template
                            >
                            <template v-else-if="!$v.phone.canadianNumber"
                                >Phone number must be a canadian
                                number</template
                            >
                        </div>
                    </div>
                    <div class="text-left text-lg-right submit-btn-wrapper">
                        <button
                            type="button"
                            class="btn btn-primary btn-lg submit-btn"
                            @click="submitForm"
                        >
                            Continue
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
const canadaPhoneFormat = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
const canadianNumber = (value) => canadaPhoneFormat.test(value);
export default {
    name: "PropertyValuationStepOne",
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            valuationTitle: "Schedule an Appointment",
        };
    },
    computed: {
        stepOneInvalid() {
            if (
                this.$v.name.$invalid ||
                this.$v.email.$invalid ||
                this.$v.phone.$invalid
            ) {
                return true;
            } else {
                return false;
            }
        },
        bannerTitle() {
            let title =
                "These questions help us reach<br /> out to explain all your<br /> options better!";
            return title;
        },
        bannerMobileTitle() {
            let title =
                "These questions help us reach out to explain all your options better!";
            return title;
        },
    },
    mounted() {},
    validations: {
        name: {
            required,
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            canadianNumber,
        },
    },
    methods: {
        getGeoLocation() {
            axios
                .get("https://freegeoip.net/json/?callback=?")
                .then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        submitForm() {
            this.$v.$touch();
            if (!this.stepOneInvalid) {
                sessionStorage.setItem("valuation_name", this.name);
                sessionStorage.setItem("valuation_email", this.email);
                sessionStorage.setItem("valuation_phone", this.phone);
                window.location.href = "/schedule/appointment";
            }
        },
        goBack() {
            window.location.href = "/";
        },
    },
};
</script>

<style scoped>
button:disabled {
    cursor: not-allowed;
}
</style>

<style>
.form-control:focus,
.form-control:active,
.form-control:active,
.form-control:visited {
    outline: none;
}
</style>
